import * as React from "react";
import { styled, alpha } from "@mui/material";

import { makeStyles } from "@mui/styles";
import Color from "color";

export const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.background.main,
    color: theme.palette.text.main, padding: theme.spacing(2)
  },

  cardContentsWrapper: {
    display: "flex",
    flexDirection: "column",

    "& *": {
      margin: theme.spacing(0.5),
    },
  },

  avatarIcon: {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),

    color: theme.palette.primary.main,
  },

  cardHeader: {
    color: theme.palette.text.main,
    fontWeight: "900",
  },

  cardText: {
    color: alpha(theme.palette.text.main, 0.7),
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },

  cardTextArea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },
}));
